import { useIntercom } from '../../hooks/useIntercom';

/**
 * Mounts the Intercom Messenger for authenticated users.
 * Renders no DOM content — the Intercom launcher is injected by the SDK.
 * Boot/update/shutdown lifecycle is managed inside useIntercom.
 */
const IntercomMessenger = () => {
  useIntercom();
  return null;
};

export default IntercomMessenger;
